<template>
  <div>
    <div  v-if="!pupopShow" class="DwPzvipHistHome">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="formInline"
            label-position="left"
            label-width="90px"
          >
            <el-form-item label="单位名称:">
              <el-input
                v-model="formInline.dwmc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="信用代码:">
              <el-input
                v-model="formInline.shtyxydm"
                placeholder="请输入"
              />
            </el-form-item>
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                round
                size="small"
                @click="loadDatasource()"
              >搜索</el-button>
              <el-button
                icon="el-icon-refresh-left"
                style="width: 90px; height: 39px"
                round
                size="small"
                @click="resetDataSource"
              >重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;">
        <div class="tablemes">
          <el-table
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  style="border: none"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addPupShow"
                >新增</el-button>
              </template>
              <el-table-column
                prop="dwmc"
                width="280px"
                label="单位名称"
              />
              <el-table-column
                prop="shtyxydm"
                label="信用代码"
              />
              <el-table-column
                prop="vipLevel"
                width="100px"
                label="等级"
              />
              <el-table-column
                prop="cjsj"
                label="配置时间"
              />
              <el-table-column
                prop="endTimeRQ"
                width="120px"
                label="过期日期"
              />
              <el-table-column
                label="生效时间"
              >
                <template slot-scope="scope">
                  {{scope.row["status"] == '0'?'':scope.row["gxsj"]}}
                </template>
              </el-table-column>
              <el-table-column
                prop="statusLabel"
                width="120px"
                label="状态"
              />
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="editPupShow(scope.row.dwmc)"
                  >重新配置</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <DwPzvipPup ref="dwPzvipPup" :nowDwmc="nowDwmc" :vipList="vipList" v-if="pupopShow"/>
  </div>
</template>

<script>
  import DwPzvipPup from '@/components/dwPzvip/dwPzvipPup'
  import {getVipLevels, getDwVipRecordList} from "@/assets/js/system";

  export default {
    components: { DwPzvipPup },
    data(){
      return {
        pupopShow: false,
        formInline: { // 搜索表单
          dwmc: '',
          shtyxydm: ''
        },
        vipList:[],
        nowDwmc:'', //传递给编辑窗口的单位名称
        tableData: [], // 表格数据
        total: 0, // 总条数
        currentPage: 1, // 当前页
        pagesize: 10, // 每页的数据条数
      }
    },
    mounted() {
      getVipLevels().then((e) => {
        this.vipList = e.data.data
      })
      this.loadDatasource()
    },
    methods:{
      // 查询列表数据
      loadDatasource() {
        getDwVipRecordList({
          page: this.currentPage,
          size: this.pagesize,
          param: this.formInline
        }).then((e) => {
          if(e.status == 200){
            this.tableData = e.data.data.rows
            this.total = e.data.data.total
          }
        })
      },
      // 重置
      resetDataSource() {
        this.formInline = {
          dwmc: '',
          shtyxydm: ''
        }
        this.loadDatasource()
      },
      // 当前页码改变时
      handleCurrentChange(val) {
        this.currentPage = val // 当前页
        this.loadDatasource()
      },
      // 10条/页改变时
      handleSizeChange(val) {
        this.pagesize = val
        this.loadDatasource()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
        if (val.length > 1) {
          this.$refs.cktable.clearSelection()
          this.$refs.cktable.toggleRowSelection(val.pop())
        }
      },
      //新增
      addPupShow(){
        this.pupopShow = true
      },
      //配置（编辑）
      editPupShow(dwmc){
        this.nowDwmc = dwmc
        this.pupopShow = true
      }
    }
  }
</script>

<style scoped lang='less'>
  .DwPzvipHistHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
        &:last-child {
          width: 90px;
          height: 39px;
          /deep/ .el-button {
            width: 90px !important;
            height: 39px;
            border-radius: 3px;
          }
        }
      }
    }
    .sousuo {
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
